import { put, all, takeEvery, fork, select, call } from "redux-saga/effects";
import { TABS, SESSION_MODAL_TABS_INSTANCE_ID } from "./constants";

import { getCredentials } from "redux/modules/user/selectors";
import { eventDetails as getPortalEventDetails } from "redux/modules/portal/selectors";

import { getters, actions } from "./model";
import { registerError } from "redux/modules/errors/actions";
import { actions as TabsActions } from "ui-kit/Tabs";
import { actions as SessionContentActions } from "../SessionContent/model";
import { push } from "react-router-redux";

import { apiCall } from "App/Data/sagas";

const getParams = function*() {
  const credentials = yield select(getCredentials);
  const eventDetails = yield select(getPortalEventDetails);

  return {
    credentials,
    eventDetails
  };
};

const init = function*({
  payload: { sessionId, hasSubsessions = false, isSubsession = false }
}) {
  try {
    yield put(actions.setLoading(true));

    const { eventDetails } = yield call(getParams);

    const { payload: sessionData } = yield call(apiCall, {
      method: "get",
      url: `/portal/event/${eventDetails.uuid}/session-content/${sessionId}/session`
    });

    yield put(
      actions.setInitialData({
        editing: Boolean(sessionId),
        sessionId,
        sessionData,
        hasSubsessions,
        isSubsession
      })
    );
  } catch (error) {
    yield put(
      registerError([
        {
          system: error,
          user: "An error occurred while loading session"
        }
      ])
    );
  } finally {
    yield put(actions.setLoading(false));
  }
};

const onTabChange = function*({ payload: tabId, meta: { instanceId } }) {
  if (instanceId !== SESSION_MODAL_TABS_INSTANCE_ID) {
    return false;
  }

  if (tabId !== TABS.CONTENT) {
    // Anytime we change away from Content tab, we have to force
    // back to loading state here so the Dropzone panel will re-render correctly
    yield put(SessionContentActions.setLoading(true));
  }

  return true;
};

const onOpenSession = function*() {
  const session = yield select(getters.data);
  yield put(push(session.url));
  return true;
};

const watchInit = function*() {
  yield takeEvery(actions.init.type, init);
};

const watchOpenSession = function*() {
  yield takeEvery(actions.openSession.type, onOpenSession);
};

const watchTabs = function*() {
  yield takeEvery(TabsActions.setSelectedTab.type, onTabChange);
};

const rootSaga = function*() {
  yield all([fork(watchInit), fork(watchTabs), fork(watchOpenSession)]);
};

export default rootSaga;
